import React from 'react';

import { Drawer as DrawerTouch, IDrawerProps } from '@ps-int/360-components/dist/components/Drawer/touch-phone';
import cn from 'classnames';

import styles from './styles.css';

export const Drawer = (props: IDrawerProps) => {
    const { className, nested, ...restProps } = props;
    return (
        <DrawerTouch
            className={cn(styles.drawer, className, { [styles.nestedDrawer]: nested })}
            nested={nested}
            {...restProps}
        />
    );
};
